import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DpWorldSidebarComponent } from './dp-world-sidebar.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [DpWorldSidebarComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
  ],
  exports: [DpWorldSidebarComponent]
})
export class DpWorldSidebarModule { }
